import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
// export const unitCategoryMap = [
//   { label: "酒店", value: 5, code: "HOTEL" },
//   { label: "餐厅", value: 3, code: "CATERING_CHAIN_LIKE" },
//   { label: "景点", value: 5, code: "SCENIC_SPOT" },
//   { label: "景区", value: 3, code: "SCENIC_AREA" },
//   { label: "集团", value: 5, code: "GROUP" },
//   { label: "管理公司", value: 3, code: "MANAGE" },
//   { label: "零售店", value: 2, code: "CATERING" },
//   { label: "链组", value: 5, code: "CHAIN" },
//   { label: "GC单位", value: 5, code: "GC" }
// ];
import Papa from "papaparse";
export const filterTree = (tree, condition) => {
  const isIncludes = (node, keywords) => {
    let {
      children
    } = node;
    if (node.name.includes(keywords) || node.code.includes(keywords)) {
      return true;
    } else if (children && children.length) {
      for (let item of children) {
        let res = isIncludes(item, keywords);
        if (res) {
          return true;
        }
      }
    }
    return false;
  };
  const searchTree = (tree, condition) => {
    let {
      keywords
    } = condition;
    let result = [];
    for (let item of tree) {
      if (item.name.includes(keywords) || item.code.includes(keywords)) {
        item.expand = true;
        result.push(item);
      } else if (item.children && isIncludes(item, keywords)) {
        item.expand = true;
        if (item.children) {
          item.children = searchTree(item.children, condition);
        }
        result.push(item);
      }
    }
    return result;
  };
  return searchTree(filterByType(JSON.parse(JSON.stringify(tree)), condition), condition);
};
const filterByType = (tree, condition) => {
  const isIncludes = (node, type) => {
    let {
      children
    } = node;
    if (type.includes(node.type) || type.length === 0) {
      return true;
    } else if (children && children.length) {
      for (let item of children) {
        let res = isIncludes(item, type);
        if (res) {
          return true;
        }
      }
    }
    return false;
  };
  const searchTree = (tree, condition) => {
    let {
      type
    } = condition;
    if (type) {
      let result = [];
      for (let item of tree) {
        if (type.includes(item.type) || type.length === 0) {
          item.expand = true;
          result.push(item);
        } else if (item.children && isIncludes(item, type)) {
          item.expand = true;
          if (item.children) {
            item.children = searchTree(item.children, condition);
          }
          result.push(item);
        }
      }
      return result;
    } else {
      return tree;
    }
  };
  return searchTree(JSON.parse(JSON.stringify(tree)), condition);
};

/*
 * 转换为小写并去除空格，并光标保持不动
 */
export function onInputRange(_this, form, formKey, key) {
  const inputId = document.getElementById(key);
  // 获取当前光标位置
  const cursorPosition = inputId.selectionStart;
  // 转换为小写并去除空格
  form[formKey] = form[formKey].replace(/\s/g, "").toLowerCase();
  // 保持光标位置不变
  _this.$nextTick(() => {
    inputId.setSelectionRange(cursorPosition, cursorPosition);
  });
}
/*
 * 树形搜索
 */
export function mapTreeJs(key, value, arr) {
  let newarr = [];
  arr.forEach(element => {
    if (element[key].toUpperCase().indexOf(value.toUpperCase()) > -1) {
      // 判断条件
      element.expand = true;
      newarr.push(element);
    } else {
      if (element.children && element.children.length > 0) {
        let redata = mapTreeJs(key, value, element.children);
        if (redata && redata.length > 0) {
          let obj = {
            ...element,
            expand: true,
            children: redata
          };
          newarr.push(obj);
        }
      }
    }
  });
  return newarr;
}
export const calculateTextLength = (text, size = 14) => {
  let html = document.createElement("span");
  html.innerHTML = text;
  html.style.fontSize = `${size}px`;
  document.body.appendChild(html);
  let width = html.offsetWidth;
  document.body.removeChild(html);
  return width;
};
export const formatDate = (date, format = "00:00:00") => {
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  return `${year}-${month}-${day} ${format}`;
};

/**
 * 将单位树形结构扁平化为列表（深度优先）
 * @param {Array} tree  树形数据，节点含 children
 * @param {Array} result 累加结果（内部使用）
 * @returns {Array} 扁平列表，保留每个节点的原始字段（code/name/unitId/children 等）
 */
export const flattenUnitTree = (tree, result = []) => {
  (tree || []).forEach(node => {
    result.push(node);
    if (node.children && node.children.length) {
      flattenUnitTree(node.children, result);
    }
  });
  return result;
};
export const auditCvsDataList = CvsString => {
  let csvData = Papa.parse(CvsString).data;
  csvData.shift(); // 删除数组第一条数据
  csvData.pop(); // 删除数组最后一条数据
  return csvData.map(item => {
    let [createTime,, userName,, eventModule, eventName, eventAction, eventResult] = item;
    return {
      createTime,
      userName,
      eventModule,
      eventName,
      eventAction,
      eventResult
    };
  });
};